/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import * as _l from 'lodash';

import permissions from '../../../common/constants/permissions';

import { AlertEventInfo } from 'services/lib/dto/AlertEventInfo';

import './details.scss';
import './details.tpl.html';

angular
  .module('batch.details', [
    'services.alertEvents',
    'services.error',
    'services.util',
    'shared.backupCountHistoryModal',
    'services.permissions'
  ])
  /**
   * Controller for the batch.details template.
   */
  .controller(
    'BatchDetailsCtrl',
    function (
      $scope,
      $state,
      $filter,
      $uibModal,
      AlertEventService,
      ErrorService,
      UtilService,
      permissionService,
      BulkRestoreType,
      TYPES,
      SOBJECT_STATE,
      BATCH_RESULT_TABS,
      VIEW_STATES,
      restorableTypes
    ) {
      // array to hold all types for easy access when all are selected.
      var METADATA = 'Metadata',
        allTypes = [],
        typesObj = {},
        metaDataTypesObj = {};

      $scope.getEventDescription = getEventDescription;
      $scope.getEvents = getEvents;
      $scope.hasEvents = hasEvents;

      $scope.resultTabs = BATCH_RESULT_TABS;
      $scope.METADATA = METADATA;

      // array to hold valid types for display.
      $scope.$parent.types = [];
      $scope.$parent.metaDataTypes = [];
      $scope.$parent.storedTypes = [];
      $scope.$parent.storedMetaDataTypes = [];
      // constant for type related data.
      $scope.TYPES = TYPES;
      $scope.SOBJECT_STATE = SOBJECT_STATE;

      $scope.notRestorableMsg = $filter('i18n')('NOT_RESTORABLE_TYPE');

      $scope.alertEventsByObjectType = {};

      /**
       * Utility to refresh the detail view.
       *
       * @returns {Promise} the promise of completion
       */
      function refreshDetails() {
        // reset these vars on refresh
        allTypes = [];
        typesObj = {};
        metaDataTypesObj = {};
        $scope.showModifiedMetadataOnly = false;
        $scope.showModifiedRecordsOnly = false;

        // If there is a batchUtils.currentBatch save off the max total as the divider in the percent
        // width calculation for the progress bars.
        if ($scope.batchUtils.currentBatch && !$scope.batchUtils.currentBatch.noBackup) {
          $scope.noBackup = false;
          $scope.divider = _.max($scope.batchUtils.currentBatch.typeCounts, function (obj) {
            return obj.total;
          }).total;

          // filter out any types that have a zero count and that have their metadata flag set to true.
          _.each($scope.batchUtils.currentBatch.typeCounts, function (counts, type) {
            // we do not want to show metadata here. Its on the metadata tab
            if (counts.total && counts.total !== 0 && !counts.md && type !== METADATA) {
              typesObj[type] = _.clone(counts);
              // save the name as part of the object
              typesObj[type].name = type;
              allTypes.push(type);
            }
          });

          // Now order by total
          $scope.$parent.types = _.sortBy(typesObj, function (obj) {
            // negative b/c I want ASC
            return -obj.total;
          });

          // The new way of displaying the metadata is to iterate over the $scope.batchUtils.currentBatch.metadataTypeCounts object.
          // If that object is undefined or empty we need to default to the old way of displaying and will just show a single 'summary' row in the
          // metadata tab.
          if (
            $scope.batchUtils.currentBatch.metadataTypeCounts &&
            !_.isEmpty($scope.batchUtils.currentBatch.metadataTypeCounts)
          ) {
            // filter out any types that have a zero count.
            _.each($scope.batchUtils.currentBatch.metadataTypeCounts, function (counts, type) {
              if (counts.total && counts.total !== 0) {
                metaDataTypesObj[type] = _.clone(counts);
                // save the name as part of the object
                metaDataTypesObj[type].name = type;
              }
            });

            $scope.$parent.metaDataTypes = _.sortBy(metaDataTypesObj, function (obj) {
              // negative b/c I want ASC
              return -obj.total;
            });
          } else if (
            $scope.batchUtils.currentBatch.typeCounts &&
            $scope.batchUtils.currentBatch.typeCounts[METADATA] &&
            $scope.batchUtils.currentBatch.typeCounts[METADATA].total &&
            $scope.batchUtils.currentBatch.typeCounts[METADATA].total !== 0
          ) {
            metaDataTypesObj[METADATA] = _.clone($scope.batchUtils.currentBatch.typeCounts[METADATA]);
            // save the name as part of the object
            metaDataTypesObj[METADATA].name = METADATA;

            // for consistency, this should be an array
            $scope.$parent.metaDataTypes = [metaDataTypesObj[METADATA]];
          }
        } else {
          $scope.noBackup = true;
        }

        // Calculate the total counts to be displayed in the header row
        $scope.recordTotals = calculateTotals($scope.$parent.types);
        $scope.metadataTotals = calculateTotals($scope.$parent.metaDataTypes);

        const batchId = $scope.batchUtils.currentBatch.batchId;

        if (batchId) {
          // Look for alert events in this batch
          AlertEventService.getEventsForBatch(batchId)
            .then((events) => {
              // Group the events by object type
              $scope.alertEventsByObjectType = _l.groupBy(events, 'objectType');

              // Comment this old code because showObjectCountChart calls
              // Display the chart if there is an initial object type
              // if ($scope.batchUtils.initialObjectType) {
              //   $scope.showObjectCountChart($scope.batchUtils.initialObjectType);
              //
              //   // Clear the initial type so it won't show again in this view
              //   $scope.batchUtils.initialObjectType = undefined;
              // }
            })
            .catch((err) => {
              ErrorService.report(err);
            });
        }
      }

      /**
       * Go to the restore items page with object type and date already selected.
       *
       * @param {Object} $event - the click event. Used to stop bubbling.
       * @param {String} objType - The selected object type.
       * @param {Number} itemCount - The number of items.
       * @param {String} objectState - The object state
       */
      $scope.goToRestoreItems = function ($event, objType, itemCount, objectState) {
        // Stop the event bubbling so row will not get selected.
        $event.preventDefault();
        $event.stopPropagation();

        // Scroll to the top where the wizard will appear
        UtilService.scrollHome();

        permissionService.hasPermission(permissions.RESTORE).then((hasPermission) => {
          if (hasPermission) {
            $state.go(VIEW_STATES.BULK_RESTORE_ENTER, {
              bulkRestoreType: BulkRestoreType.BACKUP,
              batch: $scope.batchUtils.currentBatch,
              objectStates: [objectState],
              objectType: objType
            });
          }
        });
      };

      /**
       * Get a width object based on the passed type counts.
       *
       * @param {Object} counts - A typeCounts object from a batch.
       * @returns {{width: number}} - The width to apply to the progress bar.
       */
      $scope.getBarWidth = function (counts) {
        var widthObj = { width: 0 };
        if ($scope.divider && $scope.divider !== 0) {
          widthObj.width = (counts.total / $scope.divider) * 100 + '%';
        }
        return widthObj;
      };

      /**
       * Handler for when a checkbox is toggled.
       * @param {string} typeName - The name of the type associated with the checkbox.
       */
      $scope.checkToggle = function (typeName) {
        var typesArr =
            $scope.$parent.currentTab === $scope.resultTabs.METADATA
              ? $scope.$parent.selectedMetadataTypes
              : $scope.$parent.selectedTypes,
          index = _.indexOf(typesArr, typeName);

        // add or remove the type from the selectedTypes array.
        if (index !== -1) {
          typesArr.splice(index, 1);
        } else {
          typesArr.push(typeName);
        }

        $scope.$parent.selectedCount = $scope.$parent.selectedTypes.length;
        $scope.$parent.selectedMetadataCount = $scope.$parent.selectedMetadataTypes.length;
      };

      /**
       * Handler to show items as link that goes to restore items page.
       * @param {number} count - The number of deleted items.
       * @param {string} type - The object type.
       *
       * @return {boolean} - show link or do not show link
       */
      $scope.showItemAsLink = function (count, type) {
        return count > 0 && _.contains(restorableTypes, type);
      };

      /**
       * Handler to flag types as restorable of not.
       * @param {string} type - The object type.
       *
       * @return {boolean} - if type is restorable or not
       */
      $scope.isRestorableType = function (type) {
        return _.contains(restorableTypes, type);
      };

      /**
       * Utility to determine the current checked state of a checkbox.
       *
       * @param {string} typeName - The associated type.
       * @returns {boolean} True if checked, false if not checked.
       */
      $scope.isChecked = function (typeName) {
        return (
          _.indexOf($scope.$parent.selectedTypes, typeName) !== -1 ||
          _.indexOf($scope.$parent.selectedMetadataTypes, typeName) !== -1
        );
      };

      /**
       * Returns the shortened version of the number if it is >1000.
       * @param {number} num - The number to apply the filter to.
       * @return {string} The number or shortened version of the number
       */
      $scope.getNum = function (num) {
        // Its possible that num might be undefined (backup_detail.deleted column is nullable. So, 'deleted' is not added to type object and, therefore, is undefined), so return 0 in this case.
        // If num is anything falsy, return 0.
        return $filter('shortNum')(num) || 0;
      };

      /**
       * Displays a chart showing the number of backed up items over a range of dates
       *
       * @param {String} typeName - the type of data to show the counts for
       * @param {Object} [$event] - the click that triggered this callback
       */
      $scope.showObjectCountChart = function (typeName, $event) {
        if ($event) {
          // Prevent this click from selecting the type row
          $event.stopPropagation();
        }

        // Scroll to the top where the modal will appear
        UtilService.scrollHome();

        // Open the chart for the specified type
        $uibModal.open({
          templateUrl: 'shared/modal/backupCountHistoryModal.tpl.html',
          controller: 'BackupCountHistoryModalCtrl',
          windowClass: 'sbsf-backup-count-history-modal-window',
          backdrop: 'static',
          resolve: {
            curTypeName: function () {
              return typeName;
            }
          }
        });
      };

      /**
       * Used to toggle the allChecked value.
       */
      $scope.checkAllToggle = function () {
        if ($scope.$parent.currentTab === $scope.resultTabs.METADATA) {
          $scope.$parent.allCheckedMetadata =
            $scope.$parent.allCheckedMetadata !== $scope.CHECKED_STATUS.ALL
              ? $scope.CHECKED_STATUS.ALL
              : $scope.CHECKED_STATUS.NONE;
          $scope.$parent.metaDataTypes.forEach(function (type) {
            $scope.addRemoveItem(type.name, $scope.$parent.allCheckedMetadata !== $scope.CHECKED_STATUS.ALL);
          });
        } else {
          $scope.$parent.allCheckedRecords =
            $scope.$parent.allCheckedRecords !== $scope.CHECKED_STATUS.ALL
              ? $scope.CHECKED_STATUS.ALL
              : $scope.CHECKED_STATUS.NONE;
          $scope.$parent.types.forEach(function (type) {
            $scope.addRemoveItem(type.name, $scope.$parent.allCheckedRecords !== $scope.CHECKED_STATUS.ALL);
          });
        }

        $scope.$parent.selectedCount = $scope.$parent.selectedTypes.length;
        $scope.$parent.selectedMetadataCount = $scope.$parent.selectedMetadataTypes.length;
      };

      /**
       * Function to add or remove items from selectedTypes array
       * @param {String} name - The name to add or remove
       * @param {Boolean} remove - Flag to remove item
       */
      $scope.addRemoveItem = function (name, remove) {
        var typesArr =
            $scope.$parent.currentTab === $scope.resultTabs.METADATA
              ? $scope.$parent.selectedMetadataTypes
              : $scope.$parent.selectedTypes,
          index = _.indexOf(typesArr, name);

        // add or remove the type from the selectedTypes array.
        if (!remove && index === -1) {
          typesArr.push(name);
        } else if (remove && index !== -1) {
          typesArr.splice(index, 1);
        }
      };

      /**
       * Function for filtering and undone filtering by modified types criteria.
       */
      $scope.showModifiedToggle = function () {
        const isMetadata = $scope.$parent.currentTab === $scope.resultTabs.METADATA;

        if (isMetadata && $scope.$parent.storedMetaDataTypes.length < $scope.$parent.metaDataTypes.length) {
          $scope.$parent.storedMetaDataTypes = $scope.$parent.metaDataTypes;
        }
        if (!isMetadata && $scope.$parent.storedTypes.length < $scope.$parent.types.length) {
          $scope.$parent.storedTypes = $scope.$parent.types;
        }

        if (isMetadata) {
          $scope.showModifiedMetadataOnly = !$scope.showModifiedMetadataOnly;
        } else {
          $scope.showModifiedRecordsOnly = !$scope.showModifiedRecordsOnly;
        }

        if (isMetadata) {
          if ($scope.showModifiedMetadataOnly) {
            $scope.$parent.metaDataTypes = calculateModified($scope.$parent.metaDataTypes);
          } else {
            $scope.$parent.metaDataTypes = $scope.$parent.storedMetaDataTypes;
          }
        } else {
          if ($scope.showModifiedRecordsOnly) {
            $scope.$parent.types = calculateModified($scope.$parent.types);
          } else {
            $scope.$parent.types = $scope.$parent.storedTypes;
          }
        }
      };

      refreshDetails();

      // Anytime that the currentBatch changes update the details UI.
      $scope.$watch(
        function () {
          return $scope.batchUtils.currentBatch;
        },
        function () {
          refreshDetails();
        }
      );

      /**
       * Determines the total counts for a set of record or metadata types
       *
       * @param dataByType - the type-specific data
       * @returns {{updated: number, new: number, deleted: number, undeleted: number}} - the sums of the individual counts
       */
      function calculateTotals(dataByType) {
        var totals = {
          updated: 0,
          new: 0,
          deleted: 0,
          undeleted: 0
        };

        _.each(dataByType, function (typeData) {
          if (typeData.updated) {
            totals.updated += typeData.updated;
          }

          if (typeData.new) {
            totals.new += typeData.new;
          }

          if (typeData.deleted) {
            totals.deleted += typeData.deleted;
          }

          if (typeData.undeleted) {
            totals.undeleted += typeData.undeleted;
          }
        });

        return totals;
      }

      /**
       * Determines whether there are any alert events for an object type.
       *
       * @param {object} type - the object type to be checked.
       * @returns {boolean} true if there are events for the object type.
       */
      function hasEvents(type) {
        return _.size($scope.alertEventsByObjectType[type.name]) > 0;
      }

      /**
       * Returns the description of an alert event.
       *
       * @param {object} event - the event whose description is desired.
       * @returns {string} - the description
       */
      function getEventDescription(event) {
        return AlertEventInfo.getDescription(event);
      }

      /**
       * Returns the alert events for an object type.
       *
       * @param {object} type - the object type to be checked.
       * @returns {object[]} the list of alert events for the object type
       */
      function getEvents(type) {
        return $scope.alertEventsByObjectType[type.name];
      }

      /**
       * Returns the list for modified object and metadata types.
       * @param {object[]} types - the list of object types to be checked.
       * @returns {object[]} the list of checked object types.
       */
      function calculateModified(types) {
        return types.filter((type) => {
          return type.updated > 0 || type.deleted > 0 || type.new > 0 || type.undeleted > 0;
        });
      }
    }
  );
